{
  "queryName": "curatorApprovalsRequired",
  "queryParam": null,
  "fields": [
    "username",
    "id",
    {
      "name": "fairsharingRecords",
      "fields": [
        "id",
        "name",
        "updatedAt",
        "createdAt",
        "type",
        {
          "queryName": "processingNotes",
          "fields": ["id", "note"]
        },
        {
          "queryName": "lastEditor",
          "fields": ["id", "username"]
        },
        "priority",
        {
          "queryName": "lastEditor",
          "fields": ["id", "username"]
        },
        {
          "queryName": "creator",
          "fields": ["id", "username"]
        }
      ]
    }
  ]
}
